export default __webpack_public_path__ + "cc3ecc88b89dc0a9553fa1948b710f09.png";